<pagination-template  (pageChange)="pageChange.emit($event)" [id]="id">
    <ul>
        <li class="pagination-previous">
            <button
                class="button"
                [disabled]="isFirstPage()"
                (click)="previous()"
                (keyup.enter)="previous()"
                tabindex="0"
            >
                «
            </button>
        </li>

        <li
            *ngFor="let page of pages"
            class="page-number-button"
            [class.current]="currentPage === page.value && !(isFirstPage() && isLastPage())"
        >
            <button
                class="button"
                (click)="setCurrent(page.value)"
                (keyup.enter)="setCurrent(page.value)"
                tabindex="0"
            >
                {{ page.label }}
            </button>
        </li>

        <li class="pagination-next">
            <button
                class="button"
                [disabled]="isLastPage()"
                (click)="next()"
                (keyup.enter)="next()"
                tabindex="0"
            >
                »
            </button>
        </li>
    </ul>
</pagination-template>
